import { FormGroup, Validators } from '@angular/forms';
import { TravelRequestEnum } from '@app/enums/travel-request.enum';
import { Currency } from '@models/currency';
import { Receipt } from '@models/request';
import { PersistentFormControl } from '@utility/persistent-forms';
import { Moment } from 'moment';
import { MerchantDetailsFormGroup } from '../../merchant-details/merchant-details-edit/merchant-details-edit.formgroup';
import { notWhitespaceValidator, maxLengthValidator } from '@utility/utility.validators';

export class ReceiptFormGroup extends FormGroup<{
    type: PersistentFormControl<TravelRequestEnum | null>;
    receiptDate: PersistentFormControl<Moment | null>;
    amountInLocalCurrency: PersistentFormControl<number | null>;
    amountInUsd: PersistentFormControl<number | null>;
    currency: PersistentFormControl<Currency | null>;
    file: PersistentFormControl<File | null>;
    merchant: MerchantDetailsFormGroup;
    erTrackingId: PersistentFormControl<string | null>;
    erReportingPeriod: PersistentFormControl<string | null>;
    notes: PersistentFormControl<string | null>;
}> {
    constructor(public model: Receipt | null) {
        super({
            type: new PersistentFormControl<TravelRequestEnum | null>(null, [Validators.required]),
            receiptDate: new PersistentFormControl<Moment | null>(null),
            amountInLocalCurrency: new PersistentFormControl<number | null>(null, [
                Validators.min(-1e6),
                Validators.max(1e6),
            ]),
            amountInUsd: new PersistentFormControl<number | null>(null, [Validators.min(-1e6), Validators.max(1e6)]),
            currency: new PersistentFormControl<Currency | null>(null),
            file: new PersistentFormControl<File | null>(null),
            merchant: new MerchantDetailsFormGroup(),
            erTrackingId: new PersistentFormControl<string | null>(null, [maxLengthValidator(200)]),
            erReportingPeriod: new PersistentFormControl<string | null>(null, [maxLengthValidator(200)]),
            notes: new PersistentFormControl<string | null>(null, [maxLengthValidator(500), notWhitespaceValidator()]),
        });
    }
}
